import React from 'react';

import { INovelHomeItem } from '@/interface/novel';

import List from './list';

export const CustomNovelHomeIndex: React.FC<{
  onChange: (data: INovelHomeItem[]) => void;
  value: INovelHomeItem[];
}> = (props) => {
  const { value, onChange } = props;

  const handleChange = (data: Partial<INovelHomeItem>) => {
    const hasValue = value?.some(e => e?.id === data?.id);
    let tempValue = value;
    tempValue = value?.map((e) => {
      if (e?.id === data?.id) {
        return data as any;
      }
      return e;
    }) || [];
    onChange(hasValue ? tempValue : tempValue.concat([data as any]));
  };

  const handelMove = (id: string) => {
    const index = value?.findIndex(e => e?.id === id);
    if (index > -1) {
      const tempValue = [...value];
      tempValue.splice(index, 1);
      onChange(tempValue);
    }
  };

  const handleSort = (data: INovelHomeItem[]) => {
    onChange(data);
  };

  return (
    <div>
      <List
        data={value}
        onChange={handleChange}
        onMove={handelMove}
        onSort={handleSort}
      />
    </div>
  );
};
